import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const IconWithRightMargin = styled(FontAwesomeIcon)`
  margin-right: 4px;
`;
